import { AppSetting } from './app-setting';

export class BooleanAppSetting extends AppSetting<boolean> {
  public constructor(protected _name: string, _default: boolean, protected _useStorage: boolean) {
    super(_name, _default, _useStorage);
  }
}
